/**
 * feat-305-chat-machinery-server-hist — every on-screen string for the Admin-only
 * "Manager assistant" tenant toggle, in ONE place (spec.md, Addendum 2026-10-03).
 * Edit the wording here, never at the call site.
 */

/** Switch label. */
export const ASSISTANT_TOGGLE_LABEL = 'Manager assistant';
/** InfoPopover trigger label. */
export const ASSISTANT_TOGGLE_HELP_LABEL = 'What does Manager assistant do?';
/** InfoPopover body; the lead-in is rendered bold. */
export const ASSISTANT_TOGGLE_HELP_LEAD = 'Manager assistant.';
export const ASSISTANT_TOGGLE_HELP_BODY =
  "Lets managers ask an AI assistant about a server on Server Performance History. Answers use the server's scores and shift summaries. Shift content is never shown to managers.";
/** In-flight indicator. */
export const ASSISTANT_TOGGLE_SAVING = 'Saving…';
/** Inline error. */
export const assistantToggleSaveFailed = (message?: string | null) =>
  message
    ? `Failed to update manager assistant: ${message}`
    : 'Failed to update manager assistant';
